// extracted by mini-css-extract-plugin
export default {"ranking":"styles_ranking__WseJh","ranking_lists":"styles_ranking_lists__broJL","ranking_box":"styles_ranking_box__ONkEC","ranking_box_item":"styles_ranking_box_item__AoYF3"};